import React from 'react';
import PropTypes from 'prop-types';
import { AnimatedLogo } from './AnimatedLogo';
import loopLogo from '../../assets/loop-logo.svg';

export const Logo = ({ animated = false, customLogo = null }) =>
  animated && !customLogo ? (
    <AnimatedLogo />
  ) : (
    <img
      src={customLogo ? `${process.env.REACT_APP_LOGO_URL}${customLogo}` : loopLogo}
      alt="Company logo"
      className="logo"
    />
  );

Logo.propTypes = {
  animated: PropTypes.bool,
  customLogo: PropTypes.string,
};
